
<form class="modal-body" #form="ngForm">
  <div class="form-group">
    <label translate for="createCloudGalleryModal-name">Gallery name</label>
    <input class="form-control" type="text" required [(ngModel)]="name" name="name" id="createCloudGalleryModal-name">
  </div>
  <div class="form-group">
    <label translate>Gallery description</label>
    <textarea class="form-control" [(ngModel)]="description" name="description"></textarea>
  </div>
</form>
<div class="modal-footer">
  <button class="btn btn-outline-primary" [clickBlocking]="create" [disabled]="!form.form.valid" translate>Create gallery</button>
  <button class="btn btn-outline-secondary" (click)="cancel()" translate>Cancel</button>
</div>